import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelSubscription } from '../services/subscriptions.api';
import type { CancelSubscriptionDTO } from '../types';

interface CancelSubscriptionVariables {
  id: string;
  data?: CancelSubscriptionDTO;
}

export function useCancelSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: CancelSubscriptionVariables) => cancelSubscription(id, data),
    onSuccess: (subscription) => {
      void queryClient.invalidateQueries({ queryKey: ['subscriptions', 'list'] });
      void queryClient.invalidateQueries({
        queryKey: ['subscriptions', 'detail', subscription.id],
      });
    },
  });
}
